module.exports = __webpack_public_path__ + "img/account_circle.67438584.svg";